import { render, staticRenderFns } from "./held.vue?vue&type=template&id=527f96f7&scoped=true&"
import script from "./held.vue?vue&type=script&lang=js&"
export * from "./held.vue?vue&type=script&lang=js&"
import style0 from "./held.vue?vue&type=style&index=0&id=527f96f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f96f7",
  null
  
)

export default component.exports